<!--
  author：wangjp
  description：产品二级品类管理
  date：2024年9月12日16:18:59
-->
<template>
  <div class="table_container">
    <el-row style="margin-bottom:10px">
      <el-form inline :model="searchForm">
        <el-form-item label="品类名称">
          <el-input v-model="searchForm.name" placeholder='请输入品类名称' size="medium" style="width: 100%"/>
        </el-form-item>
        <el-row>
          <el-button type="primary" icon="el-icon-plus" @click="handleAdd" size="medium">新增</el-button>
          <el-form-item style="position: absolute; right: -10px">
            <el-button type="warning" icon="el-icon-search" @click="handleSearchSubmit" size="medium">查询</el-button>
            <el-button type="info" icon="el-icon-refresh-left" @click="handleSearchReset" size="medium">重置</el-button>
          </el-form-item>
        </el-row>
      </el-form>
    </el-row>
    <el-row style="margin-top: 50px">
      <el-table highlight-current-row :data="tableData" v-loading="$store.state.loading" border>
<!--        <el-table-column width="100" type="index" :index="generSerialNum" label="序号" align="center"/>-->
        <el-table-column min-width="50" prop="name" label="品类名称" align="center"/>
        <el-table-column min-width="50" prop="pname" label="所属一级品类" align="center"/>
        <el-table-column prop="createUserName" align="center" label="创建人" width="200" :formatter="createUserFormatter"/>
        <el-table-column prop="createTime" align="center" label="创建时间" width="200"/>
        <el-table-column width="200" label="操作" align="center">
          <template slot-scope="scope">
            <el-button @click="handleEdit(scope.$index,scope.row)" type="text"><i
                class="el-icon-edit"></i><span>编辑</span></el-button>
            <el-button @click="handleDelete(scope.$index,scope.row)" type="text"><i
                class="el-icon-delete"></i><span>删除</span></el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row class="table_pagination">
      <el-pagination background :pageCount="pageCount" :currentPage="currentPage" :page-size="pageSize"
                     layout="prev, pager, next" @current-change="handleCurPageChange"
                     hide-on-single-page/>
    </el-row>
    <info-product-category2-form :formVisible.sync="formVisible" :selRow="selRow" :submitUrl="submitUrl"
                   @refreshList="getTableData"/>
  </div>
</template>

<script>
import {commonListMixin} from "@/utils/commonListMixin";
import InfoProductCategory2Form from "./form/InfoProductCategory2Form.vue";

export default {
  name: "InfoProductCategory2Index",
  components: {InfoProductCategory2Form},
  mixins: [commonListMixin],
  data() {
    return {
      userList: [],
      url: {
        list: '/core/infoProductCategory2/findPageList',
        add: '/core/infoProductCategory2/add',
        edit: '/core/infoProductCategory2/edit',
        delete: '/core/infoProductCategory2/deleteById'
      }
    }
  },
  mounted() {
    this.getUserList();
  },
  methods: {
    //创建人翻译
    createUserFormatter(row) {
      this.userList.find(item => {
        if (row.createUser == item.id) {
          row.createUserName = item.realName;
        }
      })
      return row.createUserName;
    },
    async getUserList() {
      let {obj} = await this.postRequest('/sysUser/findAll');
      this.userList = obj
    }
  }
}
</script>
